@use "@fukuri-admins/ui/layout" as *;

.container {
  width: 100%;
  padding: spacing("16");
}

.tablesWrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: spacing("16");
}

.categorySection {
  display: flex;
  flex-direction: column;
  margin-top: spacing("16");
  gap: spacing("16");
}

.categoryTitle {
  @include typography('Jp/16_W6');
  color: text('High');
  margin: 0;
}

.colNo {
  width: 50px;
  min-width: 50px;
}

.colQuestion {
  min-width: 300px;
  max-width: 500px;
}

.colAnswer {
  width: 90px;
  min-width: 90px;
}

.checkIcon {
  color: text('High');
  display: block;
  margin: 0 auto;
}
